import { styled } from "@mui/material";
import { MultiSelectElement } from "react-hook-form-mui";


export const SelectBase = styled(MultiSelectElement)({
    fontFamily: 'Rubik',
    minWidth: '150px',
    '& > .MuiSelect-multiple > div': {
        gap: '5px'
    },
    '& > fieldset': {
        // backgroundColor: 'red',
        borderRadius: '8px',
    },
    '& .MuiChip-label': {
        color: '#5a677d'
    }
})